/* global Promise */
'use strict';

var adyenWebPromise;

function waitForAdyenWeb() {
    if (window.AdyenWeb) {
        return Promise.resolve();
    }

    if (!adyenWebPromise) {
        adyenWebPromise = new Promise(function (resolve, reject) {
            var attempts = 0;
            var interval = setInterval(function () {
                if (window.AdyenWeb) {
                    clearInterval(interval);
                    resolve();
                } else if (attempts++ >= 100) {
                    clearInterval(interval);
                    reject(new Error('Adyen Web SDK failed to load'));
                }
            }, 100);
        }).catch(function (error) {
            adyenWebPromise = null;
            throw error;
        });
    }

    return adyenWebPromise;
}

function initializeCheckout(applicationInfo) {
    return waitForAdyenWeb().then(function () {
        // eslint-disable-next-line new-cap
        return window.AdyenWeb.AdyenCheckout({
            environment: window.environment,
            clientKey: window.clientKey,
            locale: window.locale,
            countryCode: window.countryCode,
            analytics: {
                analyticsData: {
                    applicationInfo: applicationInfo
                }
            }
        });
    });
}

module.exports = {
    initializeCheckout: initializeCheckout
};
